export const pageIds = {
  faq: 'eO1XEMA23CDWZfmS5QAHt',
  settings: '4FX8eGyotRRWhADcY1jzzq'
}
